import React from 'react'
import { useSummaryFormContext } from '../hook/summary-form'
import { SimpleGrid, Paper, Text, Stack, Select, NumberInput, Checkbox } from '@mantine/core'

const visibilityList = [
  {
    label: 'Live',
    value: '1',
  },
  {
    label: 'Not Live',
    value: '0',
  },
]
const notShowInCatalogList = [
  {
    label: 'Show on All Pages',
    value: '0',
  },
  {
    label: 'Only Shown on Supplier page, not show in catalog',
    value: '1',
  },
]

const defaultStatusSellerActiveList = [
  {
    label: 'Pass',
    value: 'pass',
  },
]

const defaultStatusSellerInactiveList = [
  {
    label: 'Draft',
    value: 'draft',
  },
  {
    label: 'In Review',
    value: 'in review',
  },
  {
    label: 'Rejected',
    value: 'rejected',
  },
]

const AdditionalSummaryProduct = () => {
  const form = useSummaryFormContext()

  form.watch('visibility', ({ value }) => {
    if (value === '1') {
      form.setValues((prev) => ({ ...prev, status: 'pass', not_show_in_catalog: '0' }))
    } else if (value === '0') {
      form.setValues((prev) => ({ ...prev, status: 'draft', not_show_in_catalog: '1' }))
    }
  })

  return (
    <SimpleGrid my={'lg'} cols={3} spacing={'lg'} verticalSpacing={'lg'}>
      <Paper p={'md'} withBorder shadow="xs" radius="md">
        <Text fw={500}>
          Visibility Status
        </Text>
        <Stack gap={'xs'} style={{ margin: '20px 0'}}>
          <Select
            name='visibility'
            data={visibilityList}
            key={form.key('visibility')}
            {...form.getInputProps('visibility')}
            allowDeselect={false}
            size='sm'
          />
          {
            form.values.visibility === '1' &&
            <Select
              name='not_show_in_catalog'
              data={notShowInCatalogList}
              key={form.key('not_show_in_catalog')}
              {...form.getInputProps('not_show_in_catalog')}
              allowDeselect={false}
              size='sm'
            />
          }
        </Stack>
      </Paper>

      <Paper p={'md'} withBorder shadow="xs" radius="md">
        <Text fw={500}>
          Product Status Seller
        </Text>

        <Stack gap={'sm'} style={{ margin: '20px 0'}}>
          <Select
            name='status'
            data={form.values.visibility === '1' ? defaultStatusSellerActiveList : defaultStatusSellerInactiveList}
            key={form.key('status')}
            {...form.getInputProps('status')}
            allowDeselect={false}
            size='sm'
          />

          <Text size='sm' fw={500}>
            Export Only Product ?
          </Text>
          <Checkbox
            size='xs'
            label="Yes, this product for export only"
            key={form.key('export_only')}
            {...form.getInputProps('export_only', { type: 'checkbox' }) }
          />
        </Stack>
      </Paper>

      <Paper p={'md'} withBorder shadow="xs" radius="md">
        <Text fw={500}>
          Priority Product
        </Text>

        <Text size='xs' c={'gray.6'}>
          The lower the product priority number will raise the product to the top position on the catalog page (ex: Number 1, first place)
        </Text>
        <Stack gap={'sm'} style={{ margin: '20px 0'}}>
          <NumberInput
            key={form.key('priority')}
            {...form.getInputProps('priority')}
            size='sm'
          />
        </Stack>
      </Paper>
    </SimpleGrid>
  )
}

export default AdditionalSummaryProduct